import Panel from './src/Panel'

export default Panel
